/* ==========================================================================
   DIANDA TRAVEL — About Us 页面交互脚本
   页面定位：People → Local Knowledge → Trust → Contact
   ==========================================================================
   设计原则：
   - 无依赖、轻量
   - 仅做 opacity / transform 类滚动显现，避免重排
   - 所有查询都限定在 .dd-about 内，避免污染其他页面
   ========================================================================== */
(function () {
  'use strict';


  /* ------------------------------------------------------------------
     1. 滚动显现（IntersectionObserver）
        元素带 [data-reveal] 属性，进入视口时淡入上移
        - 无 JS 时样式不生效（由 .js 作用域门控），内容始终可见
        - 同一父级内的卡片按顺序做轻微错峰
     ------------------------------------------------------------------ */
  var revealItems = document.querySelectorAll('[data-reveal]');
  if (!revealItems.length) return;

  // 老旧浏览器降级：直接全部显示，避免内容永远隐藏
  if (!('IntersectionObserver' in window)) {
    revealItems.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -48px 0px' });

  revealItems.forEach(function (el) {
    // 同一父级内的卡片做轻微错峰（最多 4 级）
    var parent = el.parentElement;
    var siblings = Array.prototype.slice.call(parent ? parent.children : []).filter(function (c) {
      return c.hasAttribute('data-reveal');
    });
    var index = siblings.indexOf(el);
    if (index > -1) {
      el.style.transitionDelay = (index % 4) * 70 + 'ms';
    }
    observer.observe(el);
  });
})();
